import types from './types';

const defaultState = {
  toggleValidationMessage: 0
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.TOGGLE_VALIDATION_MESSAGE:
      return { ...state, toggleValidationMessage: state.toggleValidationMessage + 1 };

    default:
      return state;
  }
};
